/**
 * Deterministic shuffle + cap for AMCQ module questions (IRT off).
 * Same assignment + student + module → same subset (resume-safe).
 */

function hashStringToSeed(s) {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

function mulberry32(seed) {
  let a = seed >>> 0;
  return () => {
    a += 0x6d2b79f5;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function stableShuffle(arr, seedKey) {
  const rand = mulberry32(hashStringToSeed(seedKey));
  const out = [...arr];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    const t = out[i];
    out[i] = out[j];
    out[j] = t;
  }
  return out;
}

/**
 * @param {{ fullList: any[], cap: number, seedKey: string }} opts
 * @returns {any[]}
 */
export function sampleAmcqModuleQuestions({ fullList, cap, seedKey }) {
  const list = Array.isArray(fullList) ? fullList : [];
  const n = Math.floor(Number(cap));
  if (!Number.isFinite(n) || n < 1 || list.length === 0) return list;
  const take = Math.min(n, list.length);
  if (take >= list.length) return [...list];
  const shuffled = stableShuffle(list, seedKey);
  return shuffled.slice(0, take);
}
